import React from 'react';
import { useFormState } from 'react-final-form';
import { minValue, useTranslate } from 'react-admin';
import { Box } from '@material-ui/core';
import WealthInputWrapper from '../../../../base/components/guesser/wealth-input-wrapper';
import { BooleanInput, NumberInput } from '../../../../base/components/ra/inputs';

export const PLAYER_LIMIT_FIELD_KEY = 'playerLimit';
export const UNLIMITED_PLAYER_VALUE = null;

const PlayerLimitInput = () => {
  const { values } = useFormState();
  const t = useTranslate();

  const playerLimit = values?.[PLAYER_LIMIT_FIELD_KEY];

  return (
    <>
      <WealthInputWrapper
        source={PLAYER_LIMIT_FIELD_KEY}
        key={PLAYER_LIMIT_FIELD_KEY}
        validate={minValue(
          1,
          t('ra.validation.greater', {
            min: 1,
          }),
        )}
        disabled={playerLimit === UNLIMITED_PLAYER_VALUE}
      >
        <NumberInput label="resources.brand.fields.playerLimit" />
      </WealthInputWrapper>
      <Box mt={-2.5} width="fit-content">
        <WealthInputWrapper
          source={PLAYER_LIMIT_FIELD_KEY}
          parse={(value) => (value ? UNLIMITED_PLAYER_VALUE : undefined)}
          format={(value) => value === UNLIMITED_PLAYER_VALUE}
        >
          <BooleanInput label="resources.brand.fields.unlimitedPlayer" disabledError />
        </WealthInputWrapper>
      </Box>
    </>
  );
};

export default PlayerLimitInput;
